import { forwardRef, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components/macro';
import { Flex } from 'rebass/styled-components';

import { rem } from '@blueprint/ui';

import { Text } from 'components/blueprint';

import { colors } from 'themes';
import { formatMessageTime } from 'utils/formatMessageTime';
import { MessageTime } from 'components/message-meta/MessageTime';
import { ScreenReaderOnly } from 'components/ScreenReaderOnly/ScreenReaderOnly';
import { useSafeLabel } from 'hooks';

import messages from './messages';

const { surfaceDark } = colors;

const StyledQuestion = styled(Flex)`
  align-self: end;
  background-color: ${surfaceDark};
  padding: ${rem(8)};
  border-radius: ${rem(4)} ${rem(4)} 0 ${rem(4)};
  max-width: ${rem(314)};
  overflow-wrap: anywhere;
  margin-left: ${rem(40)};
`;

/**
 * Question
 * Displaying question content
 */
export const Question = forwardRef(({ content, datetime }, ref) => {
  const containerRef = useRef(null);
  const safeLabel = useSafeLabel();

  useImperativeHandle(ref, () => ({
    scrollIntoView: () => containerRef.current?.scrollIntoView(),
  }));

  return (
    <Flex
      as="li"
      flexDirection="column"
      alignItems="flex-end"
      marginRight={rem(20)}
      marginBottom={rem(8)}
    >
      <ScreenReaderOnly>
        {safeLabel(messages.youSaidAtTime, {
          time: formatMessageTime(datetime),
        })}
      </ScreenReaderOnly>
      <StyledQuestion ref={containerRef} marginBottom={rem(5)}>
        <Text mode="dark" lineHeight={rem(20)}>
          {content}
        </Text>
      </StyledQuestion>
      <MessageTime datetime={datetime} aria-hidden />
    </Flex>
  );
});
